import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"
import { IconButton } from "@motley/design"

const IconButtonLink = createLink(
  (props: ComponentProps<typeof IconButton>) => (
    <IconButton {...props} nativeButton={false} render={<a />} />
  ),
)

export default IconButtonLink
